// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"763":"136b1e24","8795":"b81da327","9741":"b82fe579","9874":"4b594109"}[chunkId] + ".chunk.css";
};